<template>
    <div class="container pb-4 edit-profile">
        <div class="row pt-4">
            <div class="col-12">
                <h2 class="font-weight-bold edit-profile__header">
                    Company
                </h2>
            </div>
            <div class="col-12">
                <p class="edit-profile__desc">
                    Manage your company related matters in one place
                </p>
            </div>
        </div>
        <div class="tab-content">
            <div class="tab-pane fade show active">
                <ul
                    class="nav justify-content-center py-4 mx-auto"
                    style="max-width: 768px"
                >
                    <li class="nav-item col-6 p-0">
                        <a
                            class="nav-link"
                            v-bind:class="{ active: this.page === 'details' }"
                            href="javascript:void(0);"
                            @click="changePage('details')"
                            >Details</a
                        >
                    </li>
                    <li class="nav-item col-6 p-0">
                        <a
                            class="nav-link"
                            v-bind:class="{ active: this.page === 'remote' }"
                            href="javascript:void(0);"
                            @click="changePage('remote')"
                            >Remote Readiness</a
                        >
                    </li>
                </ul>
                <div class="tab-content">
                    <div
                        class="tab-pane fade"
                        v-bind:class="{
                            show: this.page === 'details',
                            active: this.page === 'details'
                        }"
                    >
                        <edit-company-details></edit-company-details>
                    </div>
                    <div
                        class="tab-pane fade"
                        v-bind:class="{
                            show: this.page === 'remote',
                            active: this.page === 'remote'
                        }"
                    >
                        <edit-company-remote-readiness></edit-company-remote-readiness>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            page: "details"
        };
    },

    methods: {
        changePage(page) {
            this.page = page;
        }
    },

    mounted() {
        if (window.location.hash.substr(1)) {
            this.page = window.location.hash.substr(1);
        }
    }
};
</script>

<style scoped lang="scss">
.edit-profile {
    &__header {
        color: #303030;
        font-family: Lato;
        font-size: 38px;
        font-weight: bold;
        letter-spacing: 0;
        line-height: 60px;
        text-align: center;
    }

    &__desc {
        color: #606064;
        font-family: "Open Sans", sans-serif;
        font-size: 16px;
        letter-spacing: 0;
        line-height: 20px;
        text-align: center;
    }

    .tab-content {
        margin-top: 42px;

        .nav-link {
            font-family: Lato;
            font-size: 16px;
            font-weight: bold;
            letter-spacing: 0;
            line-height: 19px;
            text-align: center;

            border-bottom: 1px solid #808fa4;
            padding-bottom: 20px;
            &.active {
                color: #313131;
                /* border-bottom: 4px solid #ff375e; */
                &::after {
                    content: "";
                    border-bottom: 4px solid #ff375e;
                    width: 100%;
                    height: 100%;
                    /* display: block; */
                    position: absolute;
                    left: 0;
                    top: 0;
                }
            }
        }
    }
}
</style>
